/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Compose_Preview_HideInputs */

const en_mail_compose_preview_hide = /** @type {(inputs: Mail_Compose_Preview_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide preview`)
};

const de_mail_compose_preview_hide = /** @type {(inputs: Mail_Compose_Preview_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau ausblenden`)
};

/**
* | output |
* | --- |
* | "Hide preview" |
*
* @param {Mail_Compose_Preview_HideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_preview_hide = /** @type {((inputs?: Mail_Compose_Preview_HideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_Preview_HideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_preview_hide(inputs)
	return en_mail_compose_preview_hide(inputs)
});